import ClientSection from '../components/client_components/index'

const Client = () => {
  return (
    <div className="">
      <div>{/* <Navbar />       */}</div>
      <div>
        <ClientSection />
      </div>
    </div>
  )
}

export default Client
